import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCommercetoolsProjectKey } from '@yme/selectors/common';
import { Network } from '@yme/services/network';
export function useDiscountedProducts(hyperdriveEndpoints, shouldRequest = true) {
    const projectKey = useSelector(getCommercetoolsProjectKey);
    const [hasDiscountedProducts, setHasDiscountedProducts] = useState(true);
    const hyperdriveDiscountEndpoint = useMemo(() => {
        if (!projectKey) {
            return;
        }
        const url = new URL(hyperdriveEndpoints.products);
        return `${url.origin}/products/${projectKey}/has-discount`;
    }, [hyperdriveEndpoints.products, projectKey]);
    useEffect(() => {
        if (!projectKey || !hyperdriveDiscountEndpoint || !shouldRequest) {
            return;
        }
        Network.get(hyperdriveDiscountEndpoint)
            .then(async (res) => {
            const result = res.data;
            if (result.hasDiscount === false) {
                setHasDiscountedProducts(result.hasDiscount);
            }
        })
            .catch(() => {
            // fine
        });
    }, [setHasDiscountedProducts, hyperdriveDiscountEndpoint, projectKey, shouldRequest]);
    return hasDiscountedProducts;
}
